document.addEventListener('DOMContentLoaded', () => {
  /* =========================
   * header 表示制御
   * ========================= */
  const header = document.querySelector('header');
  const menuWrapper = document.querySelector('.mas-menu-wrapper');
  const kv = document.querySelector('.mbsp-kv_wrapper');

  let ticking = false;
  let lastScrollY = window.scrollY;

  // isfixed が付いた瞬間の scrollY
  let fixedStartY = null;

  /*----------------------------------
   * アンカースクロール処理
   *---------------------------------*/
  const anchors = document.querySelectorAll('.js-anchor');
  let isAnchorScrolling = false;
  let anchorTimer = null;

  anchors.forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      e.preventDefault();
      isAnchorScrolling = true;
      clearTimeout(anchorTimer);
      anchorTimer = setTimeout(() => {
        isAnchorScrolling = false;
      }, 1500);
      const targetID = this.getAttribute('href');
      menuWrapper.classList.add('is-down');
      if (targetID === '#top') {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
          speed: 2000
        });
        return;
      } else {
        return;
      }
    });
  });




  function isSP() {
    return window.matchMedia('(max-width: 719px)').matches;
  }

  function onScroll() {
    const scrollY = window.scrollY;
    const threshold = window.innerHeight;

    /* =========================
     * header / isfixed 制御
     * ========================= */
    if (header && menuWrapper) {
      if (scrollY >= threshold) {
        // isfixed が「初めて」付いた瞬間を記録
        if (!menuWrapper.classList.contains('isfixed')) {
          fixedStartY = scrollY;
        }

        header.classList.add('isvisible');
        menuWrapper.classList.add('isfixed');
      } else {
        header.classList.remove('isvisible');
        menuWrapper.classList.remove('isfixed');
        menuWrapper.classList.remove('is-down');
        fixedStartY = null; // リセット
      }

      /* =========================
       * SP + isfixed 時の上下判定
       * ========================= */
      if (
        menuWrapper.classList.contains('isfixed') &&
        isSP() &&
        fixedStartY !== null
      ) {
        // const passed = scrollY - fixedStartY;

        // 400px 進むまでは is-down をつけない
        // if (passed >= 400) {
        //   const delta = scrollY - lastScrollY;

        //   // 微振動防止
        //   if (Math.abs(delta) > 2) {
        //     if (delta > 0) {
        //       // 下スクロール
        //       menuWrapper.classList.add('is-down');
        //     } else {
        //       // 上スクロール
        //       menuWrapper.classList.remove('is-down');
        //     }
        //   }
        // } else {
        //   // ガード中は必ず解除
        //   menuWrapper.classList.remove('is-down');
        // }
        const delta = scrollY - lastScrollY;
        if (Math.abs(delta) > 2) {
          if (isAnchorScrolling) {
            menuWrapper.classList.add('is-down');
          } else {
            if (delta > 0) {
              // 下スクロール
              menuWrapper.classList.add('is-down');
            } else {
              // 上スクロール
              menuWrapper.classList.remove('is-down');
            }
          }
        }
      } else {
        menuWrapper.classList.remove('is-down');
      }
    }

    /* =========================
     * KV parallax
     * ========================= */
    if (kv) {
      const y = scrollY * 0.1;
      kv.style.transform = `translate3d(0, -${y}px, 0)`;
    }

    lastScrollY = scrollY;
    ticking = false;
  }

  // 初期反映
  onScroll();

  window.addEventListener(
    'scroll',
    () => {
      if (!ticking) {
        requestAnimationFrame(onScroll);
        ticking = true;
      }
    },
    { passive: true }
  );

  // resize 時の保険
  window.addEventListener('resize', () => {
    if (!menuWrapper) return;
    if (!isSP()) menuWrapper.classList.remove('is-down');
  });

});


// ===== アニメーション発火 =====
	const animaElements = document.querySelectorAll("[data-scroll-anima]:not(.js-change)");
	const animaObserver = new IntersectionObserver(entries => {
		entries.forEach(entry => {
			if (entry.isIntersecting) entry.target.dataset.scrollAnima = 'true';
		});
	}, { root: null, rootMargin: '0px', threshold: .1 });
	animaElements.forEach(el => animaObserver.observe(el));


document.addEventListener('DOMContentLoaded', function () {

  const anchors = document.querySelectorAll('.js-anchor');
  // 固定ヘッダーの高さを取得（動的）
  function getHeaderHeight() {
    const header = document.querySelector('header');
    if (!header) return 0;
    return header.getBoundingClientRect().height;
  }
  anchors.forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      e.preventDefault();

      const targetID = this.getAttribute('href');
      if (targetID === '#top') {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
        return;
      }
      const target = document.querySelector(targetID);
      if (!target) return;

      const headerHeight = getHeaderHeight();
      const top = target.getBoundingClientRect().top + window.pageYOffset - headerHeight;

      window.scrollTo({
        top: top,
        behavior: 'smooth'
      });
    });
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const root = document.querySelector('.js-imageLoop');
  if (!root) return;

  const items = root.querySelectorAll('.img-item');
  const states = ['a', 'b', 'c'];

  let current = 0;
  let timer = null;
  let isPlaying = false;

  const applyState = (state) => {
    items.forEach((item, i) => {
      setTimeout(() => {
        item.classList.remove('state-a', 'state-b', 'state-c');
        item.classList.add(`state-${state}`);
      }, i * 200); // 左から0.2秒差
    });
  };

  const tick = () => {
    applyState(states[current]);
    current = (current + 1) % states.length;
  };

  const start = () => {
    if (isPlaying) return;
    isPlaying = true;

    tick(); // 画面内に入ったらすぐ1回動かす
    timer = setInterval(() => {
      tick();
    }, 3000); // 3秒ごとに切り替え
  };

  const stop = () => {
    if (!isPlaying) return;
    isPlaying = false;

    clearInterval(timer);
    timer = null;
  };

  // 初期表示
  items.forEach((item) => {
    item.classList.add('state-a');
  });

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          start();
        } else {
          stop();
        }
      });
    },
    {
      threshold: 0.3
    }
  );

  observer.observe(root);
});


document.addEventListener('DOMContentLoaded', () => {
  const el = document.querySelector('.js-mbsp-carousel');
  if (!el) return;

  new Swiper(el, {
    loop: true,
    slidesPerView: 'auto',
    speed: 11000,
    allowTouchMove: false,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
  });
});


document.addEventListener('DOMContentLoaded', () => {
  const el = document.querySelector('.js-mbspPpSwiper');
  if (!el) return;

  const mq = window.matchMedia('(max-width: 719px)');
  let swiper = null;

  const initSwiper = () => {
    if (swiper) return;

    swiper = new Swiper(el, {
      slidesPerView: 1.5,
      loop: false,
      speed: 600,
    });
  };

  const destroySwiper = () => {
    if (!swiper) return;
    swiper.destroy(true, true);
    swiper = null;
  };

  const handleChange = () => {
    if (mq.matches) {
      initSwiper();
    } else {
      destroySwiper();
    }
  };

  handleChange();

  if (mq.addEventListener) {
    mq.addEventListener('change', handleChange);
  } else {
    mq.addListener(handleChange);
  }
});

document.addEventListener('DOMContentLoaded', () => {

  // ===== 上（右方向）=====
  const topEl = document.querySelector('.js-mbsp-carousel-sp-top');
  if (topEl) {
    new Swiper(topEl, {
      loop: true,
      slidesPerView: 'auto',
      speed: 11000,
      allowTouchMove: false,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
      },
    });
  }

  // ===== 下（左方向）=====
  const bottomEl = document.querySelector('.js-mbsp-carousel-sp-bottom');
  if (bottomEl) {
    new Swiper(bottomEl, {
      loop: true,
      slidesPerView: 'auto',
      speed: 11000,
      allowTouchMove: false,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
        reverseDirection: true,
      },
    });
  }

});

document.addEventListener('DOMContentLoaded', () => {
  const video = document.querySelector('.js-kv-video');
  if (!video) return;

  const mq = window.matchMedia('(max-width: 719px)');
  let currentType = null;

  const setVideo = (isSp) => {
    const type = isSp ? 'sp' : 'pc';
    if (type === currentType) return;

    currentType = type;

    const src = isSp ? video.dataset.srcSp : video.dataset.srcPc;
    const poster = isSp ? video.dataset.posterSp : video.dataset.posterPc;

    video.pause();

    video.removeAttribute('src');
    video.poster = poster;

    const source = document.createElement('source');
    source.src = src;
    source.type = 'video/mp4';

    video.innerHTML = '';
    video.appendChild(source);

    video.load();
    setTimeout(() => {
      video.play().catch(() => {});
    }, 50);
  };

  const handleChange = () => {
    setVideo(mq.matches);
  };

  handleChange();

  if (mq.addEventListener) {
    mq.addEventListener('change', handleChange);
  } else {
    mq.addListener(handleChange);
  }
});


document.addEventListener('DOMContentLoaded', () => {
  const menu = document.querySelector('.mas-menu-items');
  const items = Array.from(document.querySelectorAll('.mas-menu-item'));
  if (!menu || items.length === 0) return;

  // indicator
  const indicator = document.createElement('span');
  indicator.className = 'mas-menu-indicator';
  menu.prepend(indicator);

  // ===== チューニング（ここだけ触ればOK）=====
  const ENTER_BUFFER = 18;   // 下へ進む時の余裕（大きいほど切替が遅くなる）
  const LEAVE_BUFFER = 40;   // 上へ戻る時の余裕（大きいほど戻りにくい）
  const COMMIT_DELAY = 160;  // 確定を遅らせるms（120〜220くらい）

  // ===== スクロール補正 =====
  // クリックでスクロールするときの補正（#aboutだけ0）
  function getClickOffset(href = '') {
    if (href === '#about') return 0;
    return window.matchMedia('(min-width: 720px)').matches ? 75 : 54;
  }
  // 現在地判定（スクロール追従）の基準ライン（共通）
  function getJudgeBaseLine() {
    return window.matchMedia('(min-width: 720px)').matches ? 75 : 54;
  }

  // #top link
  const topLink = items.find(a => (a.getAttribute('href') || '') === '#top') || null;

  // pairs（#top は除外）
  const pairs = items
    .map((a) => {
      const href = a.getAttribute('href') || '';
      if (href === '#top') return null;

      const id = href.replace('#', '');
      const section = id ? document.getElementById(id) : null;
      return section ? { a, section, href } : null;
    })
    .filter(Boolean);

  if (pairs.length === 0) {
    if (topLink) {
      items.forEach(i => i.classList.remove('current'));
      topLink.classList.add('current');
    }
    return;
  }

  let activeLink = null;
  let activeIndex = -1; // -1 は #top、0.. は pairs

  // クリック遷移中ロック（到達まで切替を止める）
  let isLocked = false;
  let lockTarget = null;
  let lockHref = null;

  // 遅延確定用
  let pendingIndex = null;
  let commitTimer = null;

  // スクロール方向検出（上向き固まり対策）
  let lastScrollY = window.scrollY;
  let scrollDir = 'down'; // 'up' | 'down'

  function applyIndicatorPosition(linkEl) {
    const menuRect = menu.getBoundingClientRect();
    const linkRect = linkEl.getBoundingClientRect();
    const y = (linkRect.top - menuRect.top) + (linkRect.height / 2) - 4;
    indicator.style.transform = `translate3d(0, ${y}px, 0)`;
  }

  function setActive(linkEl, force = false) {
    if (!linkEl) return;
    if (!force && linkEl === activeLink) return;

    if (linkEl !== activeLink) {
      items.forEach(item => item.classList.remove('current'));
      linkEl.classList.add('current');
      activeLink = linkEl;
    }
    applyIndicatorPosition(linkEl);
  }

  function setActiveByIndex(idx, force = false) {
    // idx: -1 = #top, 0..pairs.length-1 = pairs
    if (idx === -1) {
      if (topLink) {
        activeIndex = -1;
        setActive(topLink, force);
      }
      return;
    }
    const p = pairs[idx];
    if (!p) return;
    activeIndex = idx;
    setActive(p.a, force);
  }

  // ===== クリック時スクロール（PC -99px / #aboutは0）=====
  function scrollToTarget(targetEl, href) {
    const offset = getClickOffset(href);
    const top = targetEl.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({ top, behavior: 'smooth' });
  }

  // ===== 候補Indexを決める（判定：topが基準ラインより上）=====
  function getCandidateIndex() {
    // 上端付近なら #top を優先
    if (topLink && window.scrollY <= 2) return -1;

    const baseLine = getJudgeBaseLine();         // 0 or 183
    const enterLine = baseLine + ENTER_BUFFER;   // 下方向の切替ライン

    let current = null;
    for (let i = 0; i < pairs.length; i++) {
      const top = pairs[i].section.getBoundingClientRect().top;
      if (top <= enterLine) current = i;
    }
    return current === null ? -1 : current;
  }

  // ===== ヒステリシス（上方向の戻りを遅らせて“戻り”を防ぐ）=====
  function applyHysteresis(candidate) {
    // #top はそのまま
    if (activeIndex === -1) return candidate;

    // 上向きで「前のセクションに戻る」場合だけ厳しくする
    if (scrollDir === 'up' && candidate < activeIndex) {
      const baseLine = getJudgeBaseLine();
      const leaveLine = baseLine + LEAVE_BUFFER; // ★重要：+（戻り判定ライン）

      const activeTop = pairs[activeIndex].section.getBoundingClientRect().top;

      // activeTop がまだ leaveLine より上(小さい)なら戻さない
      // = もっと上に戻って activeTop が leaveLine を超えるまで待つ
      if (activeTop < leaveLine) {
        return activeIndex;
      }
    }

    return candidate;
  }

  // ===== 遅延確定（少し落ち着いてから黒丸を動かす）=====
  function scheduleCommit(nextIndex) {
    if (nextIndex === activeIndex) {
      pendingIndex = null;
      if (commitTimer) clearTimeout(commitTimer);
      commitTimer = null;
      return;
    }

    // 候補が変わったらタイマーをリセット
    if (pendingIndex !== nextIndex) {
      pendingIndex = nextIndex;
      if (commitTimer) clearTimeout(commitTimer);

      commitTimer = setTimeout(() => {
        setActiveByIndex(pendingIndex, true);
        pendingIndex = null;
        commitTimer = null;
      }, COMMIT_DELAY);
    }
  }

  // ===== スクロールで更新 =====
  function updateByScroll() {
    // クリック遷移中は目的地到達まで止める（ガタつき防止）
    if (isLocked && lockTarget) {
      const offset = getClickOffset(lockHref || '');
      const destTop = lockTarget.getBoundingClientRect().top + window.pageYOffset - offset;

      if (Math.abs(window.pageYOffset - destTop) > 6) return; // 到達許容
      isLocked = false;
      lockTarget = null;
      lockHref = null;
    }

    const candidate = getCandidateIndex();
    const filtered = applyHysteresis(candidate);
    scheduleCommit(filtered);
  }

  // 初期表示
  if (topLink && window.scrollY <= 2) {
    setActiveByIndex(-1, true);
  } else {
    setActiveByIndex(0, true);
  }
  updateByScroll();

  // scroll監視（rAFで軽量）＋方向更新
  let ticking = false;
  window.addEventListener('scroll', () => {
    if (ticking) return;
    ticking = true;

    requestAnimationFrame(() => {
      const y = window.scrollY;
      scrollDir = (y < lastScrollY) ? 'up' : 'down';
      lastScrollY = y;

      updateByScroll();
      ticking = false;
    });
  }, { passive: true });

  // リサイズ補正
  let rafId = null;
  function requestRecalc() {
    if (!activeLink) return;
    if (rafId) cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(() => {
      setActive(activeLink, true);
      updateByScroll();
      rafId = null;
    });
  }
  window.addEventListener('resize', requestRecalc);
  window.addEventListener('orientationchange', requestRecalc);

  if ('ResizeObserver' in window) {
    const ro = new ResizeObserver(requestRecalc);
    ro.observe(menu);
    items.forEach(el => ro.observe(el));
  }
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(requestRecalc).catch(() => {});
  }

  // クリック
  items.forEach((a) => {
    a.addEventListener('click', (e) => {
      const href = a.getAttribute('href') || '';
      e.preventDefault();

      // クリック時は即反映
      setActive(a, true);

      // pending/タイマーをクリア（遅延確定が割り込まないように）
      pendingIndex = null;
      if (commitTimer) clearTimeout(commitTimer);
      commitTimer = null;

      // #top
      if (href === '#top') {
        activeIndex = -1;
        isLocked = true;
        lockTarget = null;
        lockHref = href;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return;
      }

      const id = href.replace('#', '');
      const target = id ? document.getElementById(id) : null;
      if (!target) return;

      // ロック
      isLocked = true;
      lockTarget = target;
      lockHref = href;

      // スクロール（#about は補正なし）
      scrollToTarget(target, href);

      // クリック先indexを即時反映（戻り防止に効く）
      const idx = pairs.findIndex(p => p.section === target);
      if (idx >= 0) activeIndex = idx;
    });
  });
});



document.addEventListener('DOMContentLoaded', () => {
  const updateMasMenu = () => {
    const isHeaderHidden = document.querySelector('.shopify-section-header-hidden');
    const masMenu = document.querySelector('.mas-menu-wrapper');

    if (!masMenu) return;

    masMenu.classList.toggle('is-adjust', !!isHeaderHidden);
  };

  // 初回チェック
  updateMasMenu();

  // headerのクラス変更を監視
  const observer = new MutationObserver(() => {
    updateMasMenu();
  });

  observer.observe(document.body, {
    attributes: true,
    subtree: true,
    attributeFilter: ['class']
  });
});